import React, { useState,useEffect } from 'react';
import { Container, Grid, Card, CardMedia, CardContent, Typography, Button, Select, MenuItem, IconButton,  CardActionArea } from '@mui/material';
import { Link } from 'react-router-dom';
import axiosInstance from '../common/axios';
import AddToCartButton from '../components/AddToCartButton';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import {fetchSupplierProducts}  from '../service/filterService';
import { styled } from '@mui/material/styles';
import { useAuth } from '../context/AuthContext';
import { requestProductApproval, approveProduct } from '../service/supplierService';
import ProductContainer from '../auth/ProductContainer';

const SelectableCard = styled(Card)(({ theme, isSelected }) => ({
  transition: 'transform 0.2s, box-shadow 0.2s, border-color 0.2s',
  border: '2px solid transparent',
  '&:hover': {
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    transform: 'translateY(-2px)',
  },
  ...(isSelected && {
    borderColor: theme.palette.primary.main,
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
  }),
}));


const VerifyProduct = (supplierData) => {
    
     var [products, setProducts] = useState(null);
  const [selectedProductIds, setSelectedProductIds] = useState([]);
  
    const {  userSupplier  } = useAuth();
  const {
    email,
    name,
    familyName,
    givenName,
    userId,
    roles, 
    userTypes,
    partnerId,
    emailVerified,
  } = userSupplier || {};
  
   
  useEffect(() => { 
  }, []);
  
      async function  updateProducts() {
      
    const res = await requestProductApproval("", selectedProductIds);
 setProducts(res.data);
      console.log("res "+ res);
        console.log("res data: "+ res.data);
    }
  
  return ( 
<>
    <ProductContainer supplierId={null}   selectedProducts={(updatedProductIds) => setSelectedProductIds(updatedProductIds)}  productList={products} action="verify" />
          
            <Grid>
              <Button variant="contained" onClick={() => updateProducts()}>
      Sent to Approval
    </Button>
    </Grid>
</>
    )}


export default VerifyProduct;
